import { createFileRoute, redirect } from "@tanstack/react-router";

// O Kit Vida Saudável foi descontinuado: redirecionamento permanente para a home.
export const Route = createFileRoute("/kit-vida-saudavel")({
  beforeLoad: () => {
    throw redirect({ to: "/", statusCode: 301 });
  },
});
